import type { Notification } from '../../types/course';
import { MOCK_NOTIFICATIONS } from '../../constants/mockDashboard';
import type { INotificationService } from '../interfaces/INotificationService';

const delay = (ms = 400) => new Promise((r) => setTimeout(r, ms));

let _notifications: Notification[] = [...MOCK_NOTIFICATIONS];

export const notificationMock: INotificationService = {
  getAll: async (): Promise<Notification[]> => {
    await delay();
    return [..._notifications].sort((a, b) => {
      if (a.read !== b.read) return a.read ? 1 : -1;
      return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
    });
  },

  markRead: async (id: string): Promise<void> => {
    await delay(200);
    _notifications = _notifications.map((n) =>
      n.id === id ? { ...n, read: true } : n
    );
  },

  markAllRead: async (): Promise<void> => {
    await delay(300);
    _notifications = _notifications.map((n) => ({ ...n, read: true }));
  },

  deleteOne: async (id: string): Promise<void> => {
    await delay(200);
    _notifications = _notifications.filter((n) => n.id !== id);
  },

  clearAll: async (): Promise<void> => {
    await delay(300);
    _notifications = [];
  },
};
